import axios from 'axios';

function apiBase(): string {
  return String(import.meta.env.VITE_APP_API_URL ?? '').replace(/\/$/, '');
}

export type TrimOrderItem = {
  trimId: string;
  colorName: string;
  sortKey: string;
};

export type TrimOrdersResponse = {
  year: string;
  make: string;
  model: string;
  trimOrders: TrimOrderItem[];
};

export async function getTrimOrders(
  accountId: string,
  params: { year: string | number; make: string; model: string },
) {
  const { data } = await axios.get<TrimOrdersResponse>(`${apiBase()}/trim-orders`, {
    params: {
      accountId,
      year: params.year,
      make: params.make,
      model: params.model,
    },
  });
  return data;
}

export async function patchTrimOrders(
  accountId: string,
  body: {
    year: string | number;
    make: string;
    model: string;
    trimOrders: TrimOrderItem[];
  },
) {
  const { data } = await axios.patch<TrimOrdersResponse>(`${apiBase()}/trim-orders`, {
    accountId,
    year: body.year,
    make: body.make,
    model: body.model,
    trimOrders: body.trimOrders,
  });
  return data;
}
